<template>
  <section class="features-section section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">为什么选择 Claude Code？</h2>
        <p class="section-subtitle">
          体验下一代 AI 驱动的开发工具，专为提升您的编程工作流程而设计。
        </p>
      </div>
      
      <div class="features-grid">
        <div class="feature-card" v-for="feature in features" :key="feature.id">
          <div class="feature-icon">
            <span v-html="feature.icon"></span>
          </div>
          <h3 class="feature-title">{{ feature.title }}</h3>
          <p class="feature-description">{{ feature.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturesSection',
  data() {
    return {
      features: [
        {
          id: 1,
          icon: '🚀',
          title: '极速体验',
          description: '利用 Claude 先进的推理能力，在数秒内生成、调试和优化代码。'
        },
        {
          id: 2,
          icon: '🧠',
          title: '上下文感知',
          description: 'Claude 理解您的整个代码库，在项目中保持一致性和连贯性。'
        },
        {
          id: 3,
          icon: '🔧',
          title: '多语言支持',
          description: '支持 Python、JavaScript、TypeScript、Go、Rust 等数十种编程语言。'
        },
        {
          id: 4,
          icon: '🛡️',
          title: '安全设计',
          description: '企业级安全保障，本地处理和隐私优先的架构设计。'
        },
        {
          id: 5,
          icon: '🔄',
          title: 'Git 集成',
          description: '无缝集成您的 Git 工作流程 - 提交、分支和拉取请求。'
        },
        {
          id: 6,
          icon: '📊',
          title: '智能分析',
          description: '追踪您的生产力提升和代码质量改进情况。'
        }
      ]
    }
  }
}
</script>

<style scoped>
.features-section {
  background: #ffffff;
  position: relative;
}

.section-header {
  text-align: center;
  margin-bottom: 80px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
}

.section-subtitle {
  font-size: 1.25rem;
  color: #64748b;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 32px;
}

.feature-card {
  background: white;
  padding: 40px 32px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.feature-card:hover::before {
  transform: scaleX(1);
}

.feature-icon {
  font-size: 3rem;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
  border-radius: 20px;
  margin-bottom: 24px;
}

.feature-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 16px;
}

.feature-description {
  color: #64748b;
  line-height: 1.6;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .features-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .feature-card {
    padding: 32px 24px;
  }
}
</style>